import React, { useState, useRef } from 'react';
import api from '../services/api';

const FileUpload = ({ 
  onFileUploaded, 
  accept = "image/*,.pdf", 
  multiple = false, 
  maxSize = 10 * 1024 * 1024, // 10MB
  buttonText = "Choose Files",
  buttonClass = "btn btn-primary btn-sm"
}) => {
  const [uploading, setUploading] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const fileInputRef = useRef(null);

  const handleFileSelect = async (event) => {
    const files = Array.from(event.target.files);
    
    if (files.length === 0) return;

    // Validate file sizes
    const oversizedFiles = files.filter(file => file.size > maxSize);
    if (oversizedFiles.length > 0) {
      alert(`Some files are too large. Maximum size is ${(maxSize / (1024 * 1024)).toFixed(1)}MB`);
      return;
    }

    setUploading(true);

    try {
      if (multiple) {
        // Upload multiple files
        const formData = new FormData();
        files.forEach(file => {
          formData.append('files', file);
        });

        const response = await api.upload.multiple(formData);
        
        if (response.success) {
          setUploadedFiles(prev => [...prev, ...response.files]);
          if (onFileUploaded) {
            onFileUploaded(response.files);
          }
        }
      } else {
        // Upload single file
        const formData = new FormData();
        formData.append('file', files[0]);

        const response = await api.upload.single(formData);
        
        if (response.success) {
          setUploadedFiles(prev => [...prev, response.file]);
          if (onFileUploaded) {
            onFileUploaded(response.file);
          }
        }
      }
    } catch (error) {
      console.error('Upload error:', error);
      alert('Upload failed: ' + (error.response?.data?.error || error.message));
    } finally {
      setUploading(false);
      // Reset file input
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    }
  };

  const removeFile = async (fileToRemove) => {
    try {
      await api.upload.delete(fileToRemove.filename);
      setUploadedFiles(prev => prev.filter(file => file.id !== fileToRemove.id));
    } catch (error) {
      console.error('Delete error:', error);
      alert('Failed to delete file');
    }
  };

  return (
    <div className="file-upload-component">
      <div className="d-flex gap-2 align-items-center">
        <input
          ref={fileInputRef}
          type="file"
          accept={accept}
          multiple={multiple}
          onChange={handleFileSelect}
          style={{ display: 'none' }}
        />
        
        <button
          type="button"
          className={buttonClass}
          onClick={() => fileInputRef.current?.click()}
          disabled={uploading}
        >
          {uploading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Uploading...
            </>
          ) : (
            <>
              📁 {buttonText}
            </>
          )}
        </button>
      </div>

      {/* {uploadedFiles.length > 0 && (
        <div className="mt-2">
          <small className="text-muted">Uploaded files:</small>
          <div className="uploaded-files mt-1">
            {uploadedFiles.map((file, index) => (
              <div key={file.id || index} className="d-flex align-items-center bg-light p-2 rounded mb-1">
                <span className="me-2">
                  {file.type?.startsWith('image/') ? '🖼️' : '📄'}
                </span>
                <span className="small text-truncate" style={{ maxWidth: '200px' }}>
                  {file.originalName}
                </span>
                <span className="small text-muted ms-2">
                  ({(file.size / 1024).toFixed(1)} KB)
                </span>
              </div>
            ))}
          </div>
        </div>
      )} */}
    </div>
  );
};

export default FileUpload;